import React, { useEffect, useRef, useState } from 'react';
import { useStateSelector } from '../../../store/selectors';
import { PaymentPopup } from './PaymentPopup';
import { FailedEngagementFeePaymentDetails } from './FailedEngagementFeePaymentDetails';
import { isSfas } from '../../../slices/marketplace/timeline/models/enums/level-of-service.enum';
import { MarketplaceActivityEvent } from '../marketplace-activity-audit-log.model';
import { InvoiceItemReferenceTypeOptions } from '../../../models/Invoice/Enums/InvoiceItemReferenceTypeEnum';

export interface PaymentValidatorProps {
    fetchEngagement: () => void;
}

export const PaymentValidator = (props: PaymentValidatorProps) => {
    const currentEngagement = useStateSelector(
        (state) => state.timelines.currentTimeline
    );
    const [isVisible, setIsVisible] = useState<boolean>(false);
    const [fteDvms, setFteDvms] = useState(0);
    const [activeBuyersCount, setActiveBuyersCount] = useState(0);
    const [feeToPay, setFeeToPay] = useState<
        FailedEngagementFeePaymentDetails[]
    >([]);
    const axios = useStateSelector((state) => state.core.axios);
    const hasLoggedPopupRef = useRef(false);

    useEffect(() => {
        const interval = setInterval(() => {
            if (
                !currentEngagement?.isAllFeesPaidBySeller &&
                !isSfas(currentEngagement?.levelOfService)
            ) {
                retrieveNotPaidFees();
            }
        }, 5000);

        const fteDvmsCount =
            currentEngagement?.engagementProcess?.startFteDvm || 0;
        setFteDvms(fteDvmsCount);

        const buyersLenght =
            currentEngagement?.engagementProcess?.buyers?.filter(
                (f) => f.isActive
            ).length ?? 0;
        setActiveBuyersCount(buyersLenght);

        return () => clearInterval(interval);
    }, [currentEngagement]);

    const retrieveNotPaidFees = () => {
        axios
            .get(
                `/api/marketplace/MarketplacePayments/RetrieveNotPaidFees/${currentEngagement.id}`
            )
            .then((response) => {
                if (response.data.length > 0) {
                    setFeeToPay(response.data);
                    if (!hasLoggedPopupRef.current) {
                        hasLoggedPopupRef.current = true;
                        const fees: FailedEngagementFeePaymentDetails[] =
                            response.data;
                        const description = fees
                            .map((f) => {
                                const label =
                                    InvoiceItemReferenceTypeOptions.find(
                                        (opt) =>
                                            opt.value ===
                                            f.invoiceItemReferenceType
                                    )?.label ?? 'Fee';
                                return `${label} $${f.amount.toFixed(2)}`;
                            })
                            .join(', ');
                        axios
                            .post(
                                '/api/marketplace/MarketplaceActivityAuditLogs',
                                {
                                    engagementId: currentEngagement.id,
                                    event: MarketplaceActivityEvent.FailedFeesPopupVisible,
                                    description,
                                }
                            )
                            .catch(() => {});
                    }
                    setIsVisible(true);
                } else {
                    props.fetchEngagement();
                }
            });
    };

    const getCheckoutPopup = () => {
        const fee = feeToPay.find((x) => x);

        return (
            <PaymentPopup
                isVisible={isVisible}
                setIsVisible={setIsVisible}
                paymentSuccess={() => {
                    setIsVisible(false);
                    retrieveNotPaidFees();
                }}
                engagementId={currentEngagement.id}
                retryPaymentDetails={fee}
                fteDvms={fteDvms}
                activeBuyers={activeBuyersCount}
            />
        );
    };

    return feeToPay.length > 0 && isVisible ? getCheckoutPopup() : <></>;
};
